module.exports = __webpack_public_path__ + "pc/img/logo.17de62ba.png";